import { CreateUserPage } from "../CreateUserPage/CreateUserPage";

export function EditUserPage() {
  return <CreateUserPage />;
}
